// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchRow.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var extendObservable = require('mobx').extendObservable;
  var action = require('mobx').action;
  var SubscriptionDetails = require('./Izenda.SubscriptionDetails');
  var {isNil} = require('lodash/fp');

  function SchedulingSearchRow(data) {
    var props = {
      subscription: new SubscriptionDetails(),
      reportingType: '',
      reportDashboardName: '',
      createdBy: '',
      selected: false,
      id: function() {
        return this.subscription.id;
      }
    };

    extendObservable(this, props);

    data && this.populateData(data);
  }

  /**
   * Populate data
   */
  SchedulingSearchRow.prototype.populateData = action(function(data) {
    this.subscription.populate(data);
    this.reportingType = data.reportingType;
    this.reportDashboardName = data.reportDashboardName;
    this.createdBy = data.createdBy;
  });

  /**
   * get data by key
   * @param key
   * @returns {*}
   */
  SchedulingSearchRow.prototype.getDataByKey = function(key) {
    var result = this[key];
    isNil(result) && (result = this.subscription[key]);
    return result;
  };

  /**
   * Update selected
   * @param value
   */
  SchedulingSearchRow.prototype.updateSelected = function(value) {
    this.selected = value;
  };

  module.exports = SchedulingSearchRow;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SchedulingSearchRow.js